<template>
  <div class="MyBookList">
    <!-- mobile 我的书单Text -->
    <div class="titleReturn">
      <div class="return" @click="BookListReturn">
        <i class="el-icon-arrow-left"></i>
      </div>
      我的知识平台
    </div>
    <!-- menu -->
    <div class="menuWrap">
      <div class="menuTap">
        <p @click="MenuTabFn" class="nolightTap">
          我的书单<span>{{ bookTotal }}</span>
        </p>
        <p class="lightTap">
          我的订单<span>{{ orderTotal }}</span>
        </p>
        <router-link v-if="layout === 0" to="/myCart" target="_blank">
          <i></i>
          <span class="my-cart-text">我的购物车</span>
          <span class="cart-num">{{ cartNum }}</span>
        </router-link>
      </div>
    </div>

    <!-- 我的订单 -->
    <div>
      <div v-if="ishaveOrder">
        <!-- pc 订单列表 -->
        <ul class="pc_orderList" v-if="layout == 0">
          <li
            v-for="(item, index) in orderList"
            :key="index"
            @click="openOrderDetail(item.goodsId, item.id)"
          >
            <div class="infoBox">
              <div class="top">
                <span class="orderNum">订单编号</span>
                <span class="orderName">名称</span>
                <span class="orderWay">支付方式</span>
                <span class="orderMoney">支付金额</span>
                <span class="orderTime">创建时间</span>
                <span class="orderState">状态</span>
                <span class="orderOperation">操作</span>
              </div>
              <div class="bot">
                <span class="orderNum">{{ item.id }}</span>
                <span class="orderName" :title="item.goodsName">{{
                  item.goodsName
                }}</span>
                <span
                  class="orderWay AilpayWay"
                  v-if="item.paymentWay == '支付宝'"
                  >支付宝支付</span
                >
                <span
                  class="orderWay WechatWay"
                  v-else-if="item.paymentWay == '微信'"
                  >微信支付</span
                >
                <span class="orderWay" v-else>其他</span>
                <span class="orderMoney">{{ "¥ " + item.totalPrices }}</span>
                <span class="orderTime">{{ item.creationDate }}</span>
                <span
                  class="orderState StateSuccess"
                  v-if="item.orderStatus == '已成交'"
                  >成功支付</span
                >
                <span class="orderState StateError" v-else>待支付</span>
                <span class="orderOperation detailed">订单详细</span>
              </div>
              <div class="operation" v-if="item.orderStatus != '已成交'">
                <div
                  class="payment"
                  @click.stop="pay(item)"
                  v-if="!disabledAilpay || item.totalPrices === 0"
                >
                  付款
                </div>
                <div class="delOrder" @click.stop="delFn(item.id)">
                  删除订单
                </div>
              </div>
            </div>
          </li>
        </ul>

        <!-- mobile列表 -->
        <ul class="mobile_orderList" v-else>
          <li
            v-for="(item, index) in orderList"
            :key="index"
            style="padding: 15px;"
          >
            <!-- 商品信息 -->
            <router-link
              :to="{
                path: '/orderInfo',
                query: { infoId: item.goodsId, orderId: item.id }
              }"
              class="infoBox"
            >
              <div class="goodsName">
                <div
                  style="font-weight: 400; font-size: 0.32rem; overflow: hidden; text-overflow: ellipsis; white-space: nowrap;color: #333333; width: 5rem;"
                >
                  {{ item.goodsName }}
                </div>
                <div
                  style="color: #24AA3B; font-size:0.28rem;"
                  v-if="item.orderStatus == '已成交'"
                >
                  成功支付
                </div>
                <div style="color: red; font-size:0.28rem;" v-else>待支付</div>
              </div>
              <div style="margin-top: 0.3rem; color: #666666;">
                创建时间：{{ item.creationDate }}
              </div>
              <div style="margin-top: 0.2rem; color: #666666">
                订单编号：{{ item.id }}
              </div>
              <div class="orderWay" v-if="item.paymentWay == '支付宝'">
                <img src="../../assets/img/orderAilpay_mobile.svg" alt="" />
                <span style="margin-left: 0.09rem;">支付宝支付</span>
              </div>
              <div class="orderWay" v-else>
                <img src="../../assets/img/orderWechat_mobile.svg" alt="" />
                <span style="margin-left: 0.09rem;">微信支付</span>
              </div>
              <div
                style="margin-top: 6px; align-items: baseline; display: flex; justify-content: flex-end;"
              >
                <span
                  style="display: inline-block; color: #999999; margin-right: 0.1rem;"
                  >支付金额</span
                >
                <p style="font-weight: 600; font-size: 0.24rem;">￥</p>
                <span
                  style="display: inline-block; font-weight: 600; font-size: 0.36rem;"
                  >{{ item.totalPrices }}</span
                >
              </div>
            </router-link>
            <!-- 订单操作 -->
            <div
              style="display: flex; justify-content: flex-end; margin-top: 6px;"
              v-if="item.orderStatus != '已成交'"
            >
              <span class="delOrder" @click="delFn(item.id)">删除订单</span>
              <span
                class="payment"
                @click="pay(item.id)"
                v-if="!disabledAilpay || item.totalPrices === 0"
                >付款</span
              >
            </div>
          </li>
        </ul>

        <!-- 加载更多 -->
        <div class="loadMoreWrap" v-if="isshowMore">
          <p class="loadMore" @click="LoadMoreOrder">加载更多</p>
        </div>

        <!-- 订单信息弹窗 -->
        <OrdersDetail :id="infoId" :orderId="orderId" v-if="showOrderDetail" />
      </div>

      <!-- 空白页 -->
      <div class="blankWrap" v-else>
        <div class="blankBox">
          <img src="../../assets/img/blankState.svg" alt="" />
        </div>
        <a href="javascript:;" @click="goToIndexFn">去书库</a>
      </div>
    </div>
  </div>
</template>

<script>
import common from "../../assets/js/common.js";

import OrdersDetail from "../../components/OrdersDetail.vue";

export default {
  name: "MyOrderList",
  data() {
    return {
      orderList: [], // 订单列表
      showOrderDetail: false, // 订单详情
      ishaveOrder: true, // 是否有订单
      layout: 0, // 布局 0：pc端布局 1：移动端布局
      CurrentPage: 1, // 当前页
      orderTotal: 0, // 我的订单总数
      bookTotal: 0, // 我的书单数量
      isshowMore: false, // 是否显示加载更多
      infoId: undefined, // 订单详情id
      orderId: undefined, // 订单id
      disabledAilpay: false, // 支付方式相关
      payParams: undefined,
      payId: undefined,
      InformationId: undefined, // 情报id
      cartNum: 0, // 购物车数量
      defaultImg:
        'this.src="' + require("../../assets/img/default_pic.png") + '"'
    };
  },
  created() {
    // 判断是否是移动端
    let wid = window.innerWidth;
    if (wid >= 320 && wid <= 1024) {
      this.layout = 1;
    } else {
      this.layout = 0;
    }
    // wx浏览器判断
    this.JugeWx();
    // 获取订单
    this.GetOrder();
  },
  mounted() {
    // 关闭订单详情事件车
    common.$on("closeOrderDet", () => {
      this.showOrderDetail = false;
    });
  },
  methods: {
    // 去书库 pc端嵌套在隧道网的iframe中，需要使用parent才能在整个窗口加载，否则就只能显示在iframe里
    goToIndexFn() {
      window.parent.location.href = `${Const_Api_Root}/#/Index`;
    },
    // 获取购物车数量
    getCartNumFn() {
      this.$fetch("/api/ShoppingCarts/count")
        .then(res => {
          this.cartNum = res.data.count;
        })
        .catch(err => {
          throw err;
        });
    },
    // 删除按钮
    delFn(id) {
      this.$confirm("确定要删除该订单记录吗？", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      })
        .then(() => {
          this.$Del("/api/orderInfo/" + id)
            .then(res => {
              this.CurrentPage = 1;
              this.orderList = [];
              this.GetOrder();
            })
            .catch(err => {});
        })
        .catch(() => {});
    },
    // 付款
    pay(item) {
      if (!this.disabledAilpay || item.totalPrices === 0) {
        this.PcPayWay(item);
        return;
      }
      this.WeChatFn(item);
    },
    // 微信浏览器
    WeChatFn(item) {
      let code = this.GetQueryString("code"); // 获取微信授权码
      code = code ? code : ""; // code为undefined传空字符串
      let url = Const_Api_Root + "/wx_redirect.html";
      let params = {
        orderInfoId: item.id,
        code: code, // 授权码
        redirectUrl: encodeURIComponent(url), // 授权后重定向的页面
        state: encodeURIComponent(location.hash),
        paymentWay: "微信",
        goodsId: item.goodsId, // 商品号
        quantity: 1, // 数量
        SucceededUrl: Const_Api_Root + "/index.html#/paySuccess",
        FailedUrl: Const_Api_Root + "/index.html#/payError"
      };
      this.$post("/api/payment/continueToPay", params)
        .then(res => {
          // 授权地址不为空跳转到授权页面
          if (!code && res.data.authorizationUrl) {
            location.href = res.data.authorizationUrl;
            return;
          }
          this.payParams = res.data.jsApiParameters; // 得到jsapi的参数
          this.payId = res.data.orderInfoId; // 生成的订单号
          this.CallPay(); // 调起微信浏览器支付
        })
        .catch(err => {
          throw err;
        });
    },
    // 微信浏览器支付后fn
    WxPayFn(type) {
      if (type) {
        location.href =
          Const_Api_Root + "/index.html#/paySuccess?orderInfoId=" + this.payId;
      } else {
        location.href = Const_Api_Root + "/index.html#/payError";
      }
    },
    // 调用微信JS api 支付
    JsApiCall() {
      WeixinJSBridge.invoke(
        "getBrandWCPayRequest",
        JSON.parse(this.payParams), //json串
        res => {
          // 支付回调
          // get_brand_wcpay_request:ok	支付成功
          // get_brand_wcpay_request: cancel	支付过程中用户取消
          // get_brand_wcpay_request: fail	支付失败
          switch (res.err_msg) {
            case "get_brand_wcpay_request:ok":
              this.WxPayFn(true);
              break;
            case "get_brand_wcpay_request:cancel":
              this.WxPayFn(false);
              break;
            case "get_brand_wcpay_request:fail":
              this.WxPayFn(false);
              break;
            default:
              this.WxPayFn(false);
              break;
          }
        }
      );
    },
    // 微信支付
    CallPay() {
      if (typeof WeixinJSBridge == "undefined") {
        if (document.addEventListener) {
          document.addEventListener(
            "WeixinJSBridgeReady",
            this.JsApiCall,
            false
          );
        } else if (document.attachEvent) {
          document.attachEvent("WeixinJSBridgeReady", this.JsApiCall);
          document.attachEvent("onWeixinJSBridgeReady", this.JsApiCall);
        }
      } else {
        this.JsApiCall();
      }
    },
    // pc支付方式
    PcPayWay(item) {
      let params = {
        orderInfoId: item.id,
        Quantity: 1,
        PaymentWay: item.PaymentWay,
        GoodsId: item.goodsId,
        SucceededUrl: Const_Api_Root + "/index.html#/paySuccess",
        FailedUrl: Const_Api_Root + "/index.html#/payError"
      };
      this.$post("/api/payment/continueToPay", params).then(res => {
        if (item.totalPrices === 0) {
          location.href =
            Const_Api_Root + "/index.html#/paySuccess?orderInfoId=" + item.id;
          return;
        }

        if (res.data.message) {
          this.$message.error(res.data.message);
        } else {
          window.open(res.data.payUrl);
        }
      });
    },
    // 获取url对应参数名的值
    GetQueryString(name) {
      var result = location.href.match(
        new RegExp("[\?\&]" + name + "=([^\&]+)", "i")
      );
      if (result == null || result.length < 1) {
        return "";
      }

      return result[1];
    },
    // 判断是否是微信浏览器
    JugeWx() {
      var ua = navigator.userAgent.toLowerCase();
      if (ua.match(/MicroMessenger/i) == "micromessenger") {
        this.disabledAilpay = true;
      } else {
        this.disabledAilpay = false;
      }
    },
    // 获取订单
    GetOrder() {
      let params =
        "?PageNumber=" +
        this.CurrentPage +
        "&PageSize=20&OrderByDictionary[CreationDate]=desc";
      this.$fetch("/api/orderInfo/myOrderInfoList" + params)
        .then(res => {
          if (res.data.accessAllowed === false) {
            let nowHref = `${Const_Api_Root}/#/myOrderList`;
            let href =
              "https://www.tunnelling.cn/PMember/MemberLogin.aspx?returnUrl=" +
              encodeURIComponent(nowHref);
            location.href = href;
            return;
          }

          // 获取订单数量
          this.GetBookListNumFn();
          // 获取购物车数量
          this.getCartNumFn();

          let headers = JSON.parse(res.headers["x-pagination"]);
          // 判断是否有订单
          if (!headers.totalCount) {
            this.ishaveOrder = false;
            return;
          }

          this.orderTotal = headers.totalCount;
          this.orderList = this.orderList.concat(res.data);
          // 是否显示加载更多
          if (headers.hasNext) {
            this.isshowMore = true;
          } else {
            this.isshowMore = false;
          }
        })
        .catch(err => {
          throw err;
        });
    },
    // 获取我的书单数量
    GetBookListNumFn() {
      let params = "?PageNumber=1&PageSize=20";
      this.$fetch("/api/information/myBooks" + params)
        .then(res => {
          let headers = JSON.parse(res.headers["x-pagination"]);
          this.bookTotal = headers.totalCount;
        })
        .catch(err => {
          throw err;
        });
    },
    // 加载更多
    LoadMoreOrder() {
      this.CurrentPage++;
      this.GetOrder();
    },
    // 查看订单详情
    openOrderDetail(id, orderId) {
      this.infoId = id;
      this.orderId = orderId;
      this.showOrderDetail = true;
    },
    // 菜单切换
    MenuTabFn() {
      this.$router.push("/myBookList");
    },
    // 返回
    BookListReturn() {
      this.$router.go(-1);
    }
  },
  components: {
    OrdersDetail
  }
};
</script>

<style scoped>
@media screen and (min-width: 320px) and (max-width: 1024px) {
  .page {
    display: none;
  }

  /* mobile 我的书单Text */
  .titleReturn {
    width: 100%;
    height: 50px;
    line-height: 50px;
    text-align: center;
    font-size: 0.3rem;
    background-color: #0078d7;
    position: relative;
    color: #ffffff;
  }

  .titleReturn .return {
    position: absolute;
    left: 0.25rem;
    top: 50%;
    transform: translateY(-50%);
    font-size: 0.4rem;
  }

  /* menu */
  .menuWrap {
    line-height: 0.8rem;
    flex-wrap: wrap;
  }

  .menuWrap .menuTap {
    width: 100%;
    display: flex;
    align-items: center;
    background-color: #ffffff;
    height: 40px;
    line-height: 40px;
    border-bottom: solid 1px #dfdfdf;
  }

  .menuWrap .menuTap p {
    display: inline-block;
    letter-spacing: 0;
    font-size: 0.28rem;
    color: #000000;
    height: 40px;
    line-height: 40px;
    width: 50%;
    text-align: center;
  }

  .menuWrap .lightTap {
    border-bottom: 0.04rem solid #2468f2;
  }

  /* 我的订单 */
  .menuWrap .menuTap p span {
    background: #f3f3f3;
    border-radius: 0.16rem;
    line-height: 0.36rem;
    display: inline-block;
    padding: 0 0.2rem;
    font-size: 0.22rem;
    color: #666;
    vertical-align: middle;
    margin-left: 0.1rem;
  }

  /* 列表 */
  .mobile_orderList {
    width: 100%;
    /* background-color: #FFFFFF; */
  }

  .mobile_orderList li {
    margin: 15px;
    padding: 0.25rem;
    /* border-bottom: 2px solid #EEEEEE; */
    border-radius: 5px;
    background-color: #fff;
  }

  .mobile_orderList .infoBox {
    font-size: 0.28rem;
  }

  .mobile_orderList span {
    display: block;
  }

  .mobile_orderList .orderWay img {
    height: 0.34rem;
    width: 0.34rem;
  }

  .orderWay {
    display: flex;
    align-items: center;
    margin-top: 6px;
  }

  .orderWay span {
    color: #666666;
  }

  .delOrder {
    width: 1.5rem;
    line-height: 24px;
    border: 1px solid #999999;
    color: #999999;
    text-align: center;
    border-radius: 3px;
  }

  .payment {
    width: 1.5rem;
    background: linear-gradient(122deg, #fe8b2a 0%, #ff6702 100%);
    border-radius: 3px;
    color: white;
    text-align: center;
    margin-left: 0.2rem;
    line-height: 24px;
  }

  .mobile_orderList .orderInfo {
    margin-left: 0.2rem;
  }

  .goodsName {
    display: flex;
    align-items: center;
    height: 100%;
    justify-content: space-between;
  }

  .orderInfo .orderNum {
    font-size: 0.32rem;
    color: #333333;
    letter-spacing: 0;
    line-height: 0.32rem;
  }

  .orderInfo .orderState {
    margin: 0.2rem 0 0.1rem;
  }

  .orderInfo .orderState,
  .orderInfo .orderTime {
    font-size: 0.24rem;
    letter-spacing: 0;
    line-height: 0.24rem;
  }

  .StateSuccess {
    color: #52c41a;
  }

  .StateError {
    color: #e02020;
  }

  .orderInfo .orderTime {
    color: #b8b8b8;
  }

  .mobile_orderList .orderMoney {
    font-size: 0.36rem;
    color: #333333;
    letter-spacing: 0;
    line-height: 0.36rem;
  }

  /* 加载更多 */
  .loadMoreWrap {
    width: 100%;
    margin: 0.4rem 0;
  }
}

@media screen and (min-width: 1029px) {
  .titleReturn,
  .load {
    display: none;
  }

  .menuWrap,
  .MyBookList ul {
    width: 1200px;
    margin: 0 auto;
  }

  /* menu */
  .menuWrap {
    line-height: 64px;
    margin: 0px auto 12px;
    background-color: #ffffff;
  }

  .menuWrap .menuTap p {
    margin-left: 24px;
    font-size: 16px;
    letter-spacing: 0;
    text-align: left;
    line-height: 24px;
    cursor: pointer;
    display: inline-block;
  }

  .menuWrap .menuTap a {
    display: inline-block;
    margin-left: 24px;
    position: relative;
  }

  .menuWrap .menuTap a i {
    display: inline-block;
    width: 16px;
    height: 16px;
    background: url(../../assets/img/booklist_cart_icon.png) no-repeat;
    background-size: 100% 100%;
    margin-top: 2px;
  }

  .menuWrap .menuTap a .my-cart-text {
    font-size: 16px;
    color: #3a3a3a;
    margin: 0 8px 0 6px;
  }

  .menuWrap .menuTap a .cart-num {
    display: inline-block;
    width: 48px;
    height: 22px;
    line-height: 22px;
    text-align: center;
    background: #f3f3f3;
    border-radius: 21px;
    font-size: 12px;
    color: #3a3a3a;
  }

  .menuWrap .nolightTap {
    color: #c8c8c8;
  }

  .menuWrap .lightTap {
    color: #333333;
  }

  .menuWrap .menuTap p span {
    background: rgba(140, 140, 140, 0.1);
    border-radius: 12px;
    line-height: 20px;
    padding: 3px 13px;
    font-size: 12px;
    color: #000000;
    margin-left: 4px;
  }

  .menuWrap .search {
    display: flex;
    align-items: center;
    background: #f5f5f5;
    border-radius: 20px;
    width: 260px;
    height: 40px;
    margin-right: 20px;
  }

  .menuWrap .search img {
    margin: 0 12px 0 22px;
  }

  .menuWrap .search input {
    background: #f5f5f5;
  }

  /* 订单列表 */
  .pc_orderList {
    background: #ffffff;
    text-align: left;
  }

  .pc_orderList li {
    position: relative;
    padding: 0 25px;
    cursor: pointer;
  }

  .pc_orderList .infoBox {
    border-bottom: 1px solid #f5f5f5;
    padding: 17px 0;
  }

  .pc_orderList li:hover {
    background: rgba(0, 0, 0, 0.02);
  }

  .pc_orderList li span {
    display: inline-block;
  }

  .pc_orderList .orderNum {
    width: 100px;
  }

  .pc_orderList .orderName {
    width: 350px;
    font-size: 14px;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }

  .pc_orderList .orderWay {
    width: 129px;
  }

  .pc_orderList .orderMoney {
    width: 114px;
    margin-right: 49px;
  }

  .pc_orderList .orderTime {
    width: 195px;
  }

  .pc_orderList .orderState {
    width: 128px;
  }

  /* 订单列表-top */
  .pc_orderList .top .orderNum {
    font-size: 14px;
    color: #000000;
    line-height: 22px;
  }

  .pc_orderList .top .orderWay,
  .pc_orderList .top .orderMoney,
  .pc_orderList .top .orderTime,
  .pc_orderList .top .orderOperation,
  .pc_orderList .top .orderState {
    font-size: 14px;
    color: #000000;
    line-height: 22px;
    opacity: 0.45;
  }

  .pc_orderList .top .orderMoney {
    text-align: right;
  }

  /* 订单列表-bot */
  .pc_orderList .bot .orderNum,
  .pc_orderList .bot .orderTime,
  .pc_orderList .bot .orderState {
    font-size: 14px;
    color: #000000;
    line-height: 22px;
    opacity: 0.65;
  }

  .pc_orderList .bot .orderWay {
    opacity: 0.85;
    font-size: 16px;
    color: #000000;
    text-align: left;
    line-height: 24px;
    padding-left: 25px;
  }

  .pc_orderList .bot .orderMoney {
    font-size: 16px;
    color: #000000;
    text-align: right;
    line-height: 24px;
  }

  .operation {
    line-height: 26px;
    overflow: hidden;
    margin-top: 10px;
  }

  .pc_orderList .bot .orderState {
  }

  /* 支付方式-支付宝or微信 */
  .AilpayWay {
    background: url(../../assets/img/orderAlipay_icon.svg) no-repeat left center;
    background-size: 20px 20px;
  }

  .WechatWay {
    background: url(../../assets/img/orderWechat_icon.svg) no-repeat left center;
    background-size: 20px 20px;
  }

  /* 状态-成功or失败 */
  .StateSuccess::before,
  .StateError::before {
    width: 6px;
    height: 6px;
    content: " ";
    border-radius: 50%;
    display: inline-block;
    vertical-align: middle;
    margin-right: 8px;
  }

  .StateSuccess::before {
    background: #52c41a;
  }

  .StateError::before {
    background: #e02020;
  }

  .StateError {
    color: #e02020;
  }

  /* - */
  .payment {
    float: right;
    width: 80px;
    background: linear-gradient(122deg, #fe8b2a 0%, #ff6702 100%);
    border-radius: 3px;
    color: white;
    text-align: center;
    margin-left: 20px;
  }

  .delOrder {
    float: right;
    width: 75px;
    line-height: 24px;
    border: 1px solid #999999;
    color: #999999;
    text-align: center;
    border-radius: 3px;
  }

  .orderOperation {
    width: 62px;
    text-align: right;
  }

  .detailed {
    border-radius: 2px;
    color: #4690dc;
    border: 1px solid #4690dc;
    text-align: center;
  }

  .detailed:hover {
    background-color: #4690dc;
    color: white;
  }

  /* ... */
  .pc_orderList .more {
    font-size: 20px;
    color: #1890ff;
    letter-spacing: 1px;
    position: absolute;
  }

  /* 加载更多 */
  .loadMoreWrap {
    width: 1200px;
    margin: 0 auto 117px;
    padding: 16px 0 24px;
    background-color: #ffffff;
  }
}

.MyBookList {
  width: 100%;
  background: #fbfbfb;
  overflow: hidden;
}

/* menu */
.menuWrap {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

/* 列表 */
.bookList li > a {
  background: #ffffff;
  box-shadow: 0 2px 16px 0 rgba(0, 0, 0, 0.06);
  border-radius: 4px;
  display: flex;
}

.intrWrap {
  width: 100%;
}

.intrWrap h5 {
  font-size: 14px;
  color: #333333;
  letter-spacing: 0;
  line-height: 22px;
  margin-bottom: 5px;
}

.intrWrap p {
  height: 45px;
  font-size: 14px;
  color: #666666;
  letter-spacing: 0;
  line-height: 22px;
  word-break: break-all;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 2;
  overflow: hidden;
}

.chapter {
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.chapter span {
  display: inline-block;
}

.chapter .chapterIcon {
  width: 16px;
  height: 16px;
  background: url(../../assets/img/ListChapter_icon.svg) no-repeat;
}

.chapter .chapterNum {
  font-size: 14px;
  color: #424242;
  letter-spacing: 0.6px;
  line-height: 14px;
}

.chapter .readed {
  font-size: 14px;
  color: #2468f2;
  letter-spacing: 0;
  line-height: 14px;
  padding-right: 24px;
  background: url(../../assets/img/right_icon.svg) no-repeat center right;
}

/* 空白页 */
.blankWrap {
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
}

.blankWrap > a {
  width: 162px;
  line-height: 40px;
  background: #2468f2;
  border-radius: 4px;
  font-size: 14px;
  color: #ffffff;
  letter-spacing: 0;
  margin-bottom: 93px;
  text-align: center;
}

.blankBox {
  margin: 58px 0 28px;
  position: relative;
}

.blankBox > span {
  position: absolute;
  bottom: 11px;
  left: 50%;
  transform: translateX(-50%);
  font-size: 12px;
  color: #424242;
  letter-spacing: 0;
  line-height: 12px;
}

/* 我的订单 */
.MyOrder {
  width: 100%;
  background: #fbfbfb;
  overflow: hidden;
}

/* 加载更多 */
.loadMoreWrap {
  display: flex;
  justify-content: center;
}

.loadMore {
  border: 1px solid rgba(0, 0, 0, 0.15);
  border-radius: 2px;
  width: 88px;
  line-height: 32px;
  text-align: center;
  opacity: 0.65;
  font-size: 14px;
  color: #000000;
  line-height: 22px;
  cursor: pointer;
}

/* 订单信息弹窗 */
.orderInfoCover {
  width: 100%;
  height: 100%;
  text-align: left;
  background: rgba(0, 0, 0, 0.4);
  display: flex;
  align-items: center;
  justify-content: center;
  position: fixed;
  top: 0;
  left: 0;
  z-index: 999;
}

.orderDetailWrap {
  padding: 0 20px;
  background: #f7f8fa;
  background-image: linear-gradient(
    180deg,
    #bfe3ff 0%,
    rgba(231, 245, 255, 0) 15%
  );
  border-radius: 8px;
  position: relative;
}

.orderDetailWrap h2 {
  line-height: 60px;
  text-align: center;
  font-size: 14px;
  color: #333333;
}

.orderDetailWrap h3 {
  font-size: 14px;
  color: #919095;
  letter-spacing: 0.6px;
  line-height: 14px;
  margin-bottom: 12px;
}

/* 关闭 */
.orderDetailWrap > span {
  position: absolute;
  top: 15px;
  right: 20px;
  display: block;
  width: 30px;
  height: 30px;
  background: url(../../assets/img/detailsClose_icon.svg) no-repeat;
  cursor: pointer;
}

/* 订单详情 */
.orderDetail {
  width: 480px;
  border-radius: 2px;
  padding: 24px 20px;
  box-sizing: border-box;
  margin: 0 auto;
  text-align: left;
  background: #ffffff;
  margin-bottom: 20px;
}

.orderDetail p {
  margin-top: 24px;
  font-size: 14px;
  color: #333333;
  line-height: 22px;
}

.orderDetail p:first-child {
  margin-top: 0;
}

.orderDetail p > span {
  color: #666666;
  margin-right: 14px;
  font-size: 14px;
}

.orderDetail strong {
  font-size: 20px;
  line-height: 28px;
}

.orderDetail p:last-child {
  font-size: 12px;
  color: #333333;
  line-height: 20px;
}
</style>



// WEBPACK FOOTER //
// src/pages/MemberCenter/MyOrderList.vue